import cloneDeep from 'lodash/cloneDeep';
import type { Channel, DefaultGenerics } from 'stream-chat';

import getChannelName from './getChannelName';

/**
 * Creates a list of channels where each channel is deeply cloned,
 * and its `data.name` is populated if not already set.
 * If `data.name` is missing, the function assigns a name based on another member in the channel
 * (excluding the current user).
 *
 * @param {Channel<DefaultGenerics>[]} channels - An array of channel
 * objects from the `stream-chat` library.
 * @param {number} currentUserId - The ID of the current user, used to exclude
 * them when determining a fallback name for the channel.
 * @returns {Channel<DefaultGenerics>[]} A new array of deeply cloned channels with updated names.
 *
 * @example
 * const updatedChannels = getChannelsWithName(channels, 123);
 * console.log(updatedChannels);
 */

const getChannelsWithName = (channels: Channel<DefaultGenerics>[], currentUserId: number) => {
	const channelsWithName = channels.map((channel) => {
		const clonedChannel = cloneDeep(channel);

		clonedChannel.data.name = clonedChannel.data.name || getChannelName(channel, currentUserId);

		return clonedChannel;
	});

	return channelsWithName;
};

export default getChannelsWithName;
